import { render, staticRenderFns } from "./Vision-general-de-ventas.vue?vue&type=template&id=62bd31a1&scoped=true"
import script from "./Vision-general-de-ventas.vue?vue&type=script&lang=js"
export * from "./Vision-general-de-ventas.vue?vue&type=script&lang=js"
import style0 from "./Vision-general-de-ventas.vue?vue&type=style&index=0&id=62bd31a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd31a1",
  null
  
)

export default component.exports